import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  Button,
  Card,
  CardHeader,
  CardBody,
  Label,
  CardFooter,
} from "reactstrap";
import { useSafariPaymentReset } from "../../hooks/useSafariPaymentReset";
import CustomInput from "../../custom/CustomInput";
import CustomSelect from "../../custom/CustomSelect";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as actions from "../../redux/creators";
import * as Yup from "yup";
import { useSelector, useDispatch, batch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CircularLoading from "../loader/CircularIndeterminate";
import { Autocomplete, TextField } from "@mui/material";

const EnrollTuition = () => {
  const dispatch = useDispatch();
  const { isPostLoading } = useSelector((state) => state.coursereg);
  const { courseByEvents } = useSelector((state) => state.courseByEvents);
  const { batches } = useSelector((state) => state.batches);
  const { branches } = useSelector((state) => state.branches);

  useEffect(() => {
    dispatch(actions.courseByEventsGetData({ id: "4" }));
    // dispatch(actions.batchesGetData());
    // dispatch(actions.branchesGetData());
  }, []);

  const handleSubmit = (values, { setSubmitting }) => {
    const coursereg = {
      clientname: values.clientname,
      clientemail: values.clientemail,
      clientphone: values.clientphone,
      age: values.age,
      city: values.city,
      course_id: values.course_id,
      branch_id: values.branch_id,
      is_enquiry: values.is_enquiry,
      totalfees: values.totalfees,
      batch_id: values.batch_id,
      time_slot_id: values.time_slot_id,
    };
    dispatch(actions.postCourse(coursereg, setSubmitting));
    setSubmitting(true);
    return;
  };
  return (
    <React.Fragment>
      <Container>
        <div className="bg-white">
          <Row>
            <h5 className="text-center p-3">
              Please fill the form to register for batches.
            </h5>
          </Row>
          <Card>
            <CardBody>
              <Formik
                initialValues={{
                  clientname: "",
                  clientemail: "",
                  clientphone: "",
                  age: "",
                  city: "",
                  course_id: "",
                  batch_id: "",
                  branch_id: "",
                  totalfees: "0",
                  is_enquiry: "1",
                  time_slot_id: "",
                }}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape({
                  clientemail: Yup.string()
                    .required("Enter Your Email")
                    .email("Invalid Email address"),
                  clientname: Yup.string().required("required"),
                  clientphone: Yup.string().required("required"),
                  branch_id: Yup.string().required("required"),
                  course_id: Yup.string().required("required"),
                })}
              >
                {(formProps) => {
                  // const defaultProps = {
                  //   options: courseByEvents?.filter(
                  //     (itm) =>
                  //       itm?.event_id == "4" &&
                  //       formProps.values.branch_id == itm?.branch_id
                  //   ),
                  //   getOptionLabel: (option) => option.name,
                  // };
                  const defaultProps = {
                    options: courseByEvents,
                    getOptionLabel: (option) => option.name,
                  };
                  return (
                    <Form className="mt-3">
                      {console.log("formProps", formProps.values)}
                      {/* <Row className="form-group">
                        <Col md={12} className="mt-3">
                          <Label htmlFor="branch_id" className="label">
                            Your Branch:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="branch_id"
                              id="branch_id"
                              placeholder="Enter Your Course"
                              className={
                                "form-control" +
                                (formProps.errors.branch_id &&
                                formProps.touched.branch_id
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option>Select Your Branch</option>
                              {branches.length > 0 &&
                                branches.map((itm) => {
                                  return (
                                    <option value={itm.id}>{itm.name}</option>
                                  );
                                })}
                            </Field>
                            <ErrorMessage
                              name="branch_id"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row> */}
                      <Row className="form-group">
                        <Col md={12} className="mt-3">
                          <Label htmlFor="course_id" className="label">
                            Your Course:
                          </Label>
                          <InputGroup>
                            <Autocomplete
                              {...defaultProps}
                              id="course_id"
                              name="course_id"
                              getOptionSelected={(option, value) =>
                                option.id === value.id
                              }
                              onChange={(event, newValue) => {
                                formProps.setFieldValue(
                                  `course_id`,
                                  newValue?.id ?? ""
                                );
                                formProps.setFieldValue(
                                  `totalfees`,
                                  newValue?.total_amount ?? ""
                                );
                              }}
                              sx={{ width: "100%" }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Course Name *"
                                  variant="outlined"
                                  name="course_id"
                                  size="small"
                                  className="form-control"
                                  error={
                                    formProps.touched.course_id &&
                                    Boolean(formProps.errors.course_id)
                                  }
                                  helperText={
                                    formProps.touched.course_id &&
                                    formProps.errors.course_id
                                  }
                                />
                              )}
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={6} className="mt-3">
                          <Label htmlFor="weekdays" className="label">
                            No. of Students:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="weekdays"
                              id="weekdays"
                              className={
                                "form-control" +
                                (formProps.errors.weekdays &&
                                formProps.touched.weekdays
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value="">Week Day Batch</option>
                              <option value={"1"}>1</option>
                              <option value={"2"}>2</option>
                              <option value={"3"}>3</option>
                            </Field>
                            <ErrorMessage
                              name="weekdays"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-3">
                          <Label htmlFor="weekdays" className="label">
                            Number Of Class Per Week:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="weekdays"
                              id="weekdays"
                              className={
                                "form-control" +
                                (formProps.errors.weekdays &&
                                formProps.touched.weekdays
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value="">Week Day Batch</option>
                            </Field>
                            <ErrorMessage
                              name="weekdays"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={6} className="mt-3">
                          <Label htmlFor="clientname" className="label">
                            Your Name:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientname"
                              id="clientname"
                              placeholder="Enter Your Name"
                              className={
                                "form-control" +
                                (formProps.errors.clientname &&
                                formProps.touched.clientname
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientname"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-3">
                          <Label htmlFor="age" className="label">
                            Enter Age:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="age"
                              id="age"
                              placeholder="Enter Age"
                              className={
                                "form-control" +
                                (formProps.errors.age && formProps.touched.age
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="age"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={6} className="mt-3">
                          <Label htmlFor="clientemail" className="label">
                            Your Email:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientemail"
                              id="clientemail"
                              placeholder="Enter Your Email"
                              className={
                                "form-control" +
                                (formProps.errors.clientemail &&
                                formProps.touched.clientemail
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientemail"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-3">
                          <Label htmlFor="clientphone" className="label">
                            Your Mobile:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientphone"
                              id="clientphone"
                              placeholder="Enter Your Mobile"
                              className={
                                "form-control" +
                                (formProps.errors.clientphone &&
                                formProps.touched.clientphone
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientphone"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={6} className="mt-3">
                          <Label htmlFor="gender" className="label">
                            Your Pincode:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="pincode"
                              id="pincode"
                              placeholder="Enter Your pincode"
                              className={
                                "form-control" +
                                (formProps.errors.pincode &&
                                formProps.touched.pincode
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="pincode"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-3">
                          <Label htmlFor="gender" className="label">
                            Your Gender:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="gender"
                              id="gender"
                              className={
                                "form-control" +
                                (formProps.errors.gender &&
                                formProps.touched.gender
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value={""}>Select Gender</option>
                              <option value={"Male"}>Male</option>
                              <option value={"Female"}>Female</option>
                            </Field>
                            <ErrorMessage
                              name="gender"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={6} className="mt-3">
                          <Label htmlFor="address" className="label">
                            Your Address:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="address"
                              id="address"
                              placeholder="Enter Your Address"
                              className={
                                "form-control" +
                                (formProps.errors.address &&
                                formProps.touched.address
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="address"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-3">
                          <Label htmlFor="city" className="label">
                            Your Residence City:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="city"
                              id="city"
                              placeholder="Enter Your Residence City"
                              className={
                                "form-control" +
                                (formProps.errors.city && formProps.touched.city
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="city"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>

                      <div className="mt-3 mb-3 row">
                        <div className="col-12">
                          <Button
                            type="submit"
                            className="register-btn"
                            size="md"
                            block
                          >
                            {isPostLoading ? (
                              <CircularLoading />
                            ) : (
                              "REGISTER NOW"
                            )}
                          </Button>
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </CardBody>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default EnrollTuition;
